var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 12.0703H14.2617V14.0703H16.2617M16.2617 8.07031H14.2617V10.0703H16.2617M18.2617 16.0703H10.2617V14.0703H12.2617V12.0703H10.2617V10.0703H12.2617V8.07031H10.2617V6.07031H18.2617M8.26172 4.07031H6.26172V2.07031H8.26172M8.26172 8.07031H6.26172V6.07031H8.26172M8.26172 12.0703H6.26172V10.0703H8.26172M8.26172 16.0703H6.26172V14.0703H8.26172M4.26172 4.07031H2.26172V2.07031H4.26172M4.26172 8.07031H2.26172V6.07031H4.26172M4.26172 12.0703H2.26172V10.0703H4.26172M4.26172 16.0703H2.26172V14.0703H4.26172M10.2617 4.07031V0.0703125H0.261719V18.0703H20.2617V4.07031H10.2617Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company-icon.6f295cd4329696eaa6c4c1b88a563c58.svg";
export { ForwardRef as ReactComponent };